var AUTO_CALC_EFFECT_MEASURES, DEFAULT_CI_LEVEL, DEFAULT_DOSE_RESPONSE, DEFAULT_DOWNGRADE, DEFAULT_LARGE_EFFECT, DEFAULT_PLAUSIBLE_CONFOUNDING, DEFAULT_PUBLICATION_BIAS, DesignStudies, FOLLOW_UP_UNITS, GRADEPRO_CONTINUOUS_OTHER_MEASURES, GRADEPRO_RELATIVE_OTHER_MEASURES, MAX_ABSOLUTE_EFFECTS, PIVOT_DOSE_RESPONSE_TO_SCORE, PIVOT_DOWNGRADE_TO_SCORE, PIVOT_LARGE_EFFECT_TO_SCORE, PIVOT_PLAUSIBLE_CONFOUNDING_TO_SCORE, PIVOT_PUBLICATION_BIAS_TO_SCORE, PIVOT_RELATIVE_MEASURE_TO_GDT, PIVOT_TO_IMPORTANCE, PIVOT_TO_OUTCOME_TYPE, PIVOT_TO_QUALITY, QUALITY_DOMAIN_KEYS, QUALITY_MODIFIER_PROPS, QUALITY_RATING_FIELDS, QualityScores, STUDY_TYPE_RANDOMIZED, VALID_OUTCOME_TYPES, addFootnote, applyMetaType, applyOverallQualityToDomains, canAutoCalculateAbsLevel, clampQualityScore, computeQualityScore, deepenDowngrade, designStudiesFor, disableUnsupportedAbsAutoCalc, downgradeForScore, ensureOutcomeRequiredDefaults, flipAbsFromPivot, hasEstimateData, hasImportedAbsLevel, hasPooledEstimate, hasQualityDomainComments, hasQualityDomainRatings, htmlToPlainText, insertHtmlBlockGaps, isNamedIdentifierField, isProportion, isStringName, isValidCiLevel, isValidSof, lightenDowngrade, mapComparatorEffect, mapContinuousEffect, mapDichotomousAbsoluteEffects, mapDichotomousEffect, mapDomainComments, mapEvidenceSource, mapGroupCounts, mapNarrativeEffect, mapOutcome, mapOutcomeType, mapPreferredDirection, mapQuality, mapRatedDomain, mapRelativeMeasure, mapTimeframe, nameOf, parseNumber, raiseDoseResponse, raiseLargeEffect, raisePlausibleConfounding, scaleAbsToDenominator, scaleControlRiskToPercent, stripHTML, _ref,
  __indexOf = [].indexOf || function(item) { for (var i = 0, l = this.length; i < l; i++) { if (i in this && this[i] === item) return i; } return -1; };

_ref = require('./enums'), PIVOT_TO_IMPORTANCE = _ref.PIVOT_TO_IMPORTANCE, PIVOT_TO_QUALITY = _ref.PIVOT_TO_QUALITY, PIVOT_TO_OUTCOME_TYPE = _ref.PIVOT_TO_OUTCOME_TYPE, PIVOT_DOWNGRADE_TO_SCORE = _ref.PIVOT_DOWNGRADE_TO_SCORE, PIVOT_PUBLICATION_BIAS_TO_SCORE = _ref.PIVOT_PUBLICATION_BIAS_TO_SCORE, PIVOT_LARGE_EFFECT_TO_SCORE = _ref.PIVOT_LARGE_EFFECT_TO_SCORE, PIVOT_DOSE_RESPONSE_TO_SCORE = _ref.PIVOT_DOSE_RESPONSE_TO_SCORE, PIVOT_PLAUSIBLE_CONFOUNDING_TO_SCORE = _ref.PIVOT_PLAUSIBLE_CONFOUNDING_TO_SCORE, PIVOT_RELATIVE_MEASURE_TO_GDT = _ref.PIVOT_RELATIVE_MEASURE_TO_GDT, GRADEPRO_RELATIVE_OTHER_MEASURES = _ref.GRADEPRO_RELATIVE_OTHER_MEASURES, GRADEPRO_CONTINUOUS_OTHER_MEASURES = _ref.GRADEPRO_CONTINUOUS_OTHER_MEASURES, FOLLOW_UP_UNITS = _ref.FOLLOW_UP_UNITS, STUDY_TYPE_RANDOMIZED = _ref.STUDY_TYPE_RANDOMIZED, DEFAULT_CI_LEVEL = _ref.DEFAULT_CI_LEVEL;

DesignStudies = require('models/outcome/design_studies');

QualityScores = require('models/outcome/quality_scores');

stripHTML = require('lib/question_tags_helper').stripHTML;

DEFAULT_DOWNGRADE = QualityScores.None;

DEFAULT_PUBLICATION_BIAS = QualityScores.None;

DEFAULT_LARGE_EFFECT = QualityScores.No;

DEFAULT_DOSE_RESPONSE = QualityScores.No;

DEFAULT_PLAUSIBLE_CONFOUNDING = QualityScores.No;

parseNumber = function(value) {
  var num;
  if (!((value != null) && value !== '')) {
    return void 0;
  }
  num = _.isNumber(value) ? value : parseFloat(value);
  if (_.isNaN(num)) {
    return void 0;
  } else {
    return num;
  }
};

nameOf = function(field) {
  var _ref1;
  if (field == null) {
    return '';
  }
  if (_.isString(field)) {
    return field;
  } else {
    return (_ref1 = field.name) != null ? _ref1 : '';
  }
};

insertHtmlBlockGaps = function(html) {
  return String(html).replace(/<br\s*\/?>/gi, ' ').replace(/<\/(?:p|div|li|tr|h[1-6]|blockquote|section|article)>/gi, ' ');
};

htmlToPlainText = function(html) {
  var doc, str, text, _ref1, _ref2;
  if (html == null) {
    return '';
  }
  str = insertHtmlBlockGaps(html);
  text = typeof DOMParser !== 'undefined' ? (doc = new DOMParser().parseFromString(str, 'text/html'), ((_ref1 = doc.body) != null ? _ref1.textContent : void 0) || ((_ref2 = doc.body) != null ? _ref2.innerText : void 0) || '') : stripHTML(str).replace(/&nbsp;/gi, ' ').replace(/&#160;/gi, ' ').replace(/&#x0*a0;/gi, ' ').replace(/&amp;/gi, '&').replace(/&lt;/gi, '<').replace(/&gt;/gi, '>').replace(/&quot;/gi, '"').replace(/&#39;/gi, "'");
  return text.replace(/\u00a0/g, ' ').replace(/\s+/g, ' ').trim();
};

isProportion = function(value) {
  return (value != null) && Math.abs(value) <= 1;
};

scaleAbsToDenominator = function(value, denominator) {
  if (value == null) {
    return void 0;
  }
  if ((denominator != null) && denominator !== 0 && isProportion(value)) {
    return value * denominator;
  } else {
    return value;
  }
};

scaleControlRiskToPercent = function(value) {
  if (value == null) {
    return void 0;
  }
  if (isProportion(value)) {
    return value * 100;
  } else {
    return value;
  }
};

flipAbsFromPivot = function(estimate, denominator) {
  var from, result, to, value;
  if (estimate == null) {
    return {};
  }
  value = scaleAbsToDenominator(parseNumber(estimate.value), denominator);
  from = scaleAbsToDenominator(parseNumber(estimate['ci-start']), denominator);
  to = scaleAbsToDenominator(parseNumber(estimate['ci-end']), denominator);
  result = {};
  if (value != null) {
    result.size = -value;
  }
  result.from = to != null ? -to : void 0;
  result.to = from != null ? -from : void 0;
  return result;
};

mapTimeframe = function(timeframe) {
  var applyUnit, fromUnitText, length, match, parseUnitKey, rangeMatch, result, text, toUnitText, unitText, _ref1, _ref2, _ref3;
  if (!((timeframe != null) && String(timeframe).trim() !== '')) {
    return {};
  }
  text = String(timeframe).trim();
  parseUnitKey = function(unitText) {
    var normalized;
    if (!unitText) {
      return null;
    }
    normalized = String(unitText).replace(/\s+/g, '');
    switch (normalized.toLowerCase()) {
      case 'day':
      case 'days':
        return 'days';
      case 'week':
      case 'weeks':
        return 'weeks';
      case 'month':
      case 'months':
        return 'months';
      case 'year':
      case 'years':
        return 'years';
      case 'hour':
      case 'hours':
        return 'hours';
      case 'patientyear':
      case 'patientyears':
      case 'patient-years':
        return 'patientYears';
      default:
        return null;
    }
  };
  applyUnit = function(result, unitText, unitKey, othersKey) {
    var parsed;
    if (!unitText) {
      return result;
    }
    parsed = parseUnitKey(unitText);
    if ((parsed != null) && __indexOf.call(FOLLOW_UP_UNITS, parsed) >= 0) {
      result[unitKey] = parsed;
    } else {
      result[unitKey] = 'others';
      result[othersKey] = unitText;
    }
    return result;
  };
  rangeMatch = text.match(/^(\d+(?:\.\d+)?)\s*(.*?)\s+to\s+(\d+(?:\.\d+)?)\s*(.*)$/i);
  if (rangeMatch != null) {
    fromUnitText = ((_ref1 = rangeMatch[2]) != null ? _ref1 : '').trim();
    toUnitText = ((_ref2 = rangeMatch[4]) != null ? _ref2 : '').trim();
    if (!fromUnitText && toUnitText) {
      fromUnitText = toUnitText;
    }
    if (!toUnitText && fromUnitText) {
      toUnitText = fromUnitText;
    }
    result = {
      followUpLength: parseFloat(rangeMatch[1]),
      followUpLengthTo: parseFloat(rangeMatch[3]),
      followUpType: 'range'
    };
    applyUnit(result, fromUnitText, 'followUpTimeUnit', 'othersFollowUpTimeUnit');
    applyUnit(result, toUnitText, 'followUpToTimeUnit', 'othersFollowUpToTimeUnit');
    return result;
  }
  match = text.match(/^(\d+(?:\.\d+)?)\s*(.*)$/);
  if (match == null) {
    return {
      followUpLength: 0,
      followUpTimeUnit: 'others',
      othersFollowUpTimeUnit: text
    };
  }
  length = parseFloat(match[1]);
  unitText = ((_ref3 = match[2]) != null ? _ref3 : '').trim();
  result = {
    followUpLength: length
  };
  if (!unitText) {
    return result;
  }
  applyUnit(result, unitText, 'followUpTimeUnit', 'othersFollowUpTimeUnit');
  return result;
};

designStudiesFor = function(studyType) {
  var ds;
  if (studyType === STUDY_TYPE_RANDOMIZED) {
    ds = _.clone(DesignStudies.get('RandTrials'));
    ds.fullName = 'RandTrials.randomised_trials';
    return ds;
  } else if (studyType != null) {
    return DesignStudies.get('ObsStudies', 'other_design');
  } else {
    return void 0;
  }
};

mapRelativeMeasure = function(relativeEffect) {
  var estimate, mapping, measure, otherLabel, result, _ref1, _ref2;
  if (relativeEffect == null) {
    return {};
  }
  measure = relativeEffect['effect-measure'];
  result = {};
  mapping = PIVOT_RELATIVE_MEASURE_TO_GDT[measure];
  if (mapping != null) {
    otherLabel = relativeEffect['other-effect-measure'];
    if (measure === 'OTHER' && __indexOf.call(GRADEPRO_RELATIVE_OTHER_MEASURES, otherLabel) >= 0) {
      result.effectMeasure = otherLabel;
    } else {
      result.effectMeasure = mapping.effectMeasure;
      if (mapping.otherMeasure != null) {
        result.otherMeasure = mapping.otherMeasure;
      } else if (measure === 'OTHER') {
        result.otherMeasure = otherLabel != null ? otherLabel : '';
      }
    }
  } else if (measure != null) {
    result.effectMeasure = 'other';
    result.otherMeasure = (_ref1 = relativeEffect['other-effect-measure']) != null ? _ref1 : measure;
  }
  estimate = relativeEffect.estimate;
  if (estimate != null) {
    result.effectSize = parseNumber(estimate.value);
    result.confidenceIntervalFrom = parseNumber(estimate['ci-start']);
    result.confidenceIntervalTo = parseNumber(estimate['ci-end']);
  }
  if (((_ref2 = result.effectMeasure) === 'VEOR' || _ref2 === 'VEHR') && (result.effectSize != null)) {
    result.vaccineEstimate = parseFloat(((1 - result.effectSize) * 100).toFixed(2));
  }
  return result;
};

mapGroupCounts = function(group, prefix) {
  var cases, result, sample;
  if (group == null) {
    return {};
  }
  result = {};
  cases = parseNumber(group.cases);
  sample = parseNumber(group['sample-size']);
  if (cases != null) {
    result["" + prefix + "Count"] = cases;
  }
  if (sample != null) {
    result["" + prefix + "Total"] = sample;
  }
  return result;
};

addFootnote = function(footnotesState, comment, refs) {
  var id, plain;
  plain = htmlToPlainText(comment);
  if (!plain) {
    return;
  }
  footnotesState.currentId += 1;
  id = footnotesState.currentId;
  footnotesState.notes[String(id)] = plain;
  footnotesState.idsOrder.push(id);
  return refs.push(id);
};

mapDomainComments = function(rating, footnotesState, domainKey, outcomeFootnotes) {
  var comment, comments, refs, _i, _len, _ref1;
  comments = (_ref1 = rating != null ? rating.comments : void 0) != null ? _ref1 : [];
  refs = [];
  for (_i = 0, _len = comments.length; _i < _len; _i++) {
    comment = comments[_i];
    addFootnote(footnotesState, comment, refs);
  }
  if (refs.length) {
    return outcomeFootnotes[domainKey] = refs;
  }
};

mapRatedDomain = function(rating, footnotesState, domainKey, outcomeFootnotes, scoreMap) {
  var score;
  if (rating == null) {
    return void 0;
  }
  mapDomainComments(rating, footnotesState, domainKey, outcomeFootnotes);
  if (!rating.value) {
    return void 0;
  }
  score = scoreMap[rating.value];
  if (score == null) {
    return void 0;
  }
  return _.clone(score);
};

QUALITY_RATING_FIELDS = [
  {
    pivotKey: 'risk-of-bias',
    gdtKey: 'riskOfBias',
    scores: PIVOT_DOWNGRADE_TO_SCORE,
    fallback: DEFAULT_DOWNGRADE
  }, {
    pivotKey: 'inconsistency',
    gdtKey: 'inconsistency',
    scores: PIVOT_DOWNGRADE_TO_SCORE,
    fallback: DEFAULT_DOWNGRADE
  }, {
    pivotKey: 'indirectness',
    gdtKey: 'indirectness',
    scores: PIVOT_DOWNGRADE_TO_SCORE,
    fallback: DEFAULT_DOWNGRADE
  }, {
    pivotKey: 'imprecision',
    gdtKey: 'imprecision',
    scores: PIVOT_DOWNGRADE_TO_SCORE,
    fallback: DEFAULT_DOWNGRADE
  }, {
    pivotKey: 'publication-bias',
    gdtKey: 'publicationBias',
    scores: PIVOT_PUBLICATION_BIAS_TO_SCORE,
    fallback: DEFAULT_PUBLICATION_BIAS
  }, {
    pivotKey: 'large-effect',
    gdtKey: 'largeEffect',
    scores: PIVOT_LARGE_EFFECT_TO_SCORE,
    fallback: DEFAULT_LARGE_EFFECT
  }, {
    pivotKey: 'dose-response-gradient',
    gdtKey: 'doseResponseGradient',
    scores: PIVOT_DOSE_RESPONSE_TO_SCORE,
    fallback: DEFAULT_DOSE_RESPONSE
  }, {
    pivotKey: 'plausible-confounding',
    gdtKey: 'plausibleConfounding',
    scores: PIVOT_PLAUSIBLE_CONFOUNDING_TO_SCORE,
    fallback: DEFAULT_PLAUSIBLE_CONFOUNDING
  }
];

QUALITY_DOMAIN_KEYS = _.pluck(QUALITY_RATING_FIELDS, 'pivotKey');

QUALITY_MODIFIER_PROPS = _.pluck(QUALITY_RATING_FIELDS, 'gdtKey');

VALID_OUTCOME_TYPES = ['DICHOTOMOUS', 'CONTINUOUS', 'OTHER_NUMERIC', 'NARRATIVE'];

hasQualityDomainRatings = function(quality) {
  return _.some(QUALITY_RATING_FIELDS, function(field) {
    var value, _ref1;
    value = quality != null ? (_ref1 = quality[field.pivotKey]) != null ? _ref1.value : void 0 : void 0;
    return (value != null) && (field.scores[value] != null);
  });
};

hasQualityDomainComments = function(quality) {
  return _.some(QUALITY_DOMAIN_KEYS, function(key) {
    var _ref1, _ref2;
    return ((_ref1 = quality != null ? (_ref2 = quality[key]) != null ? _ref2.comments : void 0 : void 0) != null ? _ref1 : []).length > 0;
  });
};

computeQualityScore = function(outcome) {
  var baseScore, _ref1;
  baseScore = (_ref1 = outcome.designStudies) != null ? _ref1.baseScore : void 0;
  if (baseScore == null) {
    return null;
  }
  return QUALITY_MODIFIER_PROPS.reduce(function(acc, prop) {
    var _ref2;
    if (((_ref2 = outcome[prop]) != null ? _ref2.score : void 0) != null) {
      acc += outcome[prop].score;
    }
    return acc;
  }, baseScore);
};

clampQualityScore = function(score) {
  return Math.max(1, Math.min(4, score));
};

downgradeForScore = function(score, allowExtreme) {
  if (allowExtreme == null) {
    allowExtreme = false;
  }
  switch (score) {
    case -3:
      if (allowExtreme) {
        return _.clone(QualityScores.ExtremelySerious);
      } else {
        return _.clone(QualityScores.VerySerious);
      }
      break;
    case -2:
      return _.clone(QualityScores.VerySerious);
    case -1:
      return _.clone(QualityScores.Serious);
    default:
      return _.clone(QualityScores.None);
  }
};

deepenDowngrade = function(outcome, prop, remaining, allowExtreme) {
  var applied, current, minAllowed, targetScore, _ref1, _ref2;
  if (allowExtreme == null) {
    allowExtreme = false;
  }
  if (!(remaining > 0)) {
    return remaining;
  }
  current = (_ref1 = (_ref2 = outcome[prop]) != null ? _ref2.score : void 0) != null ? _ref1 : 0;
  minAllowed = prop === 'publicationBias' ? -1 : allowExtreme ? -3 : -2;
  if (current <= minAllowed) {
    return remaining;
  }
  targetScore = Math.max(minAllowed, current - remaining);
  applied = current - targetScore;
  if (!(applied > 0)) {
    return remaining;
  }
  outcome[prop] = downgradeForScore(targetScore, allowExtreme);
  return remaining - applied;
};

raiseLargeEffect = function(outcome, remaining) {
  var applied, current, targetScore, _ref1, _ref2;
  if (!(remaining > 0)) {
    return remaining;
  }
  current = (_ref1 = (_ref2 = outcome.largeEffect) != null ? _ref2.score : void 0) != null ? _ref1 : 0;
  if (current >= 2) {
    return remaining;
  }
  targetScore = Math.min(2, current + remaining);
  applied = targetScore - current;
  if (!(applied > 0)) {
    return remaining;
  }
  outcome.largeEffect = targetScore >= 2 ? _.clone(QualityScores.VeryLarge) : _.clone(QualityScores.Large);
  return remaining - applied;
};

raiseDoseResponse = function(outcome, remaining) {
  var current, _ref1, _ref2;
  if (!(remaining > 0)) {
    return remaining;
  }
  current = (_ref1 = (_ref2 = outcome.doseResponseGradient) != null ? _ref2.score : void 0) != null ? _ref1 : 0;
  if (current >= 1) {
    return remaining;
  }
  outcome.doseResponseGradient = _.clone(QualityScores.Yes);
  return remaining - 1;
};

raisePlausibleConfounding = function(outcome, remaining) {
  var current, _ref1, _ref2;
  if (!(remaining > 0)) {
    return remaining;
  }
  current = (_ref1 = (_ref2 = outcome.plausibleConfounding) != null ? _ref2.score : void 0) != null ? _ref1 : 0;
  if (current >= 1) {
    return remaining;
  }
  outcome.plausibleConfounding = _.clone(QualityScores.IncreasedForRR);
  return remaining - 1;
};

lightenDowngrade = function(outcome, prop, remaining, allowExtreme) {
  var applied, current, targetScore, _ref1, _ref2;
  if (allowExtreme == null) {
    allowExtreme = false;
  }
  if (!(remaining > 0)) {
    return remaining;
  }
  current = (_ref1 = (_ref2 = outcome[prop]) != null ? _ref2.score : void 0) != null ? _ref1 : 0;
  if (current >= 0) {
    return remaining;
  }
  targetScore = Math.min(0, current + remaining);
  applied = targetScore - current;
  if (!(applied > 0)) {
    return remaining;
  }
  outcome[prop] = downgradeForScore(targetScore, allowExtreme);
  return remaining - applied;
};

applyOverallQualityToDomains = function(outcome, targetQuality) {
  var baseScore, clamped, delta, finalScore, raw, remaining, target, _ref1, _ref2, _ref3;
  target = Number(targetQuality);
  if (!((target != null) && !_.isNaN(target))) {
    return;
  }
  outcome.quality = target;
  baseScore = (_ref1 = outcome.designStudies) != null ? _ref1.baseScore : void 0;
  if (baseScore == null) {
    return;
  }
  raw = (_ref2 = computeQualityScore(outcome)) != null ? _ref2 : baseScore;
  clamped = clampQualityScore(raw);
  if (clamped === target) {
    return;
  }
  delta = target - raw;
  if (delta === 0) {
    return;
  }
  if (delta < 0) {
    remaining = -delta;
    remaining = deepenDowngrade(outcome, 'imprecision', remaining, true);
    remaining = deepenDowngrade(outcome, 'riskOfBias', remaining, false);
    remaining = deepenDowngrade(outcome, 'inconsistency', remaining, false);
    remaining = deepenDowngrade(outcome, 'indirectness', remaining, false);
    remaining = deepenDowngrade(outcome, 'publicationBias', remaining, false);
  } else {
    remaining = delta;
    remaining = raiseLargeEffect(outcome, remaining);
    remaining = raiseDoseResponse(outcome, remaining);
    remaining = raisePlausibleConfounding(outcome, remaining);
    if (remaining > 0) {
      remaining = lightenDowngrade(outcome, 'publicationBias', remaining, false);
      remaining = lightenDowngrade(outcome, 'indirectness', remaining, false);
      remaining = lightenDowngrade(outcome, 'inconsistency', remaining, false);
      remaining = lightenDowngrade(outcome, 'riskOfBias', remaining, false);
      remaining = lightenDowngrade(outcome, 'imprecision', remaining, true);
    }
  }
  finalScore = (_ref3 = computeQualityScore(outcome)) != null ? _ref3 : target;
  return outcome.quality = clampQualityScore(finalScore);
};

mapQuality = function(quality, footnotesState) {
  var field, hasComments, hasDomainComments, hasDomainRatings, hasOverall, outcomeFootnotes, result, _i, _j, _len, _len1, _ref1, _ref2;
  if (quality == null) {
    return {};
  }
  outcomeFootnotes = {};
  result = {};
  hasOverall = PIVOT_TO_QUALITY[quality.value] != null;
  hasDomainRatings = hasQualityDomainRatings(quality);
  hasDomainComments = hasQualityDomainComments(quality);
  hasComments = ((_ref1 = quality.comments) != null ? _ref1 : []).length > 0;
  if (!(hasOverall || hasDomainRatings || hasDomainComments || hasComments)) {
    return {};
  }
  if (hasOverall) {
    result._pivotQuality = Number(PIVOT_TO_QUALITY[quality.value]);
  }
  mapDomainComments(quality, footnotesState, 'quality', outcomeFootnotes);
  if (hasOverall || hasDomainRatings) {
    for (_i = 0, _len = QUALITY_RATING_FIELDS.length; _i < _len; _i++) {
      field = QUALITY_RATING_FIELDS[_i];
      result[field.gdtKey] = (_ref2 = mapRatedDomain(quality[field.pivotKey], footnotesState, field.gdtKey, outcomeFootnotes, field.scores)) != null ? _ref2 : _.clone(field.fallback);
    }
  } else if (hasDomainComments) {
    for (_j = 0, _len1 = QUALITY_RATING_FIELDS.length; _j < _len1; _j++) {
      field = QUALITY_RATING_FIELDS[_j];
      mapDomainComments(quality[field.pivotKey], footnotesState, field.gdtKey, outcomeFootnotes);
    }
  }
  if (!_.isEmpty(outcomeFootnotes)) {
    result.footnotes = outcomeFootnotes;
  }
  return result;
};

MAX_ABSOLUTE_EFFECTS = 3;

mapDichotomousAbsoluteEffects = function(effect) {
  var DEFAULT_ABS_DENOMINATOR, absEffect, absEffects, assumedLevels, calculatedCount, calculatedLevel, comparatorRisk, denominator, flipped, hasCalculatedEntry, hasEstimate, index, isCalculatedRisk, levels, mapping, orderedEffects, result, scalingDenominator, _i, _len, _ref1;
  absEffects = (_ref1 = effect != null ? effect['absolute-effects'] : void 0) != null ? _ref1 : [];
  result = {};
  denominator = parseNumber(effect != null ? effect.denominator : void 0);
  DEFAULT_ABS_DENOMINATOR = 1000;
  scalingDenominator = denominator != null ? denominator : DEFAULT_ABS_DENOMINATOR;
  if (absEffects.length || (denominator != null)) {
    result.absDenominator = scalingDenominator;
    result.perPatients = scalingDenominator;
  }
  if (!absEffects.length) {
    return result;
  }
  if (absEffects.length > MAX_ABSOLUTE_EFFECTS) {
    throw new Error('tooManyAbsoluteEffects');
  }
  isCalculatedRisk = function(absEffect) {
    return absEffect['comparator-risk-is-calculated'] !== false;
  };
  calculatedCount = _.filter(absEffects, isCalculatedRisk).length;
  if (calculatedCount > 1) {
    throw new Error('tooManyCalculatedAbsoluteEffects');
  }
  hasCalculatedEntry = calculatedCount > 0;
  orderedEffects = hasCalculatedEntry ? _.sortBy(absEffects, function(absEffect, index) {
    return (isCalculatedRisk(absEffect) ? 0 : 1) * 1000 + index;
  }) : absEffects;
  calculatedLevel = {
    size: 'absEffectSize',
    from: 'absEffectFrom',
    to: 'absEffectTo',
    auto: 'absEffectAutoCalc',
    risk: 'calculatedControlValue',
    flag: 'calculatedControl',
    riskAsString: true,
    isPrimary: true
  };
  assumedLevels = [
    {
      size: 'absEffectSizeLow',
      from: 'absEffectFromLow',
      to: 'absEffectToLow',
      auto: 'absEffectAutoCalcLow',
      risk: 'lowControlRisk',
      flag: 'lowControl',
      label: 'lowControlLabel',
      riskAsString: false
    }, {
      size: 'absEffectSizeModerate',
      from: 'absEffectFromModerate',
      to: 'absEffectToModerate',
      auto: 'absEffectAutoCalcModerate',
      risk: 'moderateControlRisk',
      flag: 'moderateControl',
      label: 'moderateControlLabel',
      riskAsString: false
    }, {
      size: 'absEffectSizeHigh',
      from: 'absEffectFromHigh',
      to: 'absEffectToHigh',
      auto: 'absEffectAutoCalcHigh',
      risk: 'highControlRisk',
      flag: 'highControl',
      label: 'highControlLabel',
      riskAsString: false
    }
  ];
  levels = hasCalculatedEntry ? [calculatedLevel].concat(assumedLevels) : assumedLevels;
  if (!hasCalculatedEntry) {
    result.calculatedControl = false;
  }
  for (index = _i = 0, _len = orderedEffects.length; _i < _len; index = ++_i) {
    absEffect = orderedEffects[index];
    mapping = levels[index];
    if (mapping == null) {
      break;
    }
    flipped = flipAbsFromPivot(absEffect.estimate, scalingDenominator);
    if (flipped.size != null) {
      result[mapping.size] = flipped.size;
    }
    if (flipped.from != null) {
      result[mapping.from] = flipped.from;
    }
    if (flipped.to != null) {
      result[mapping.to] = flipped.to;
    }
    hasEstimate = (flipped.size != null) || (flipped.from != null) || (flipped.to != null);
    if (hasEstimate || (absEffect['estimate-is-calculated'] != null)) {
      result[mapping.auto] = absEffect['estimate-is-calculated'] === true;
    }
    comparatorRisk = scaleControlRiskToPercent(parseNumber(absEffect['comparator-risk']));
    if (comparatorRisk != null) {
      result[mapping.risk] = mapping.riskAsString ? String(comparatorRisk) : comparatorRisk;
    }
    result[mapping.flag] = true;
    if (mapping.label != null) {
      result[mapping.label] = '';
    }
    if (mapping.isPrimary) {
      result.calculatedControl = isCalculatedRisk(absEffect);
    }
  }
  return result;
};

mapPreferredDirection = function(direction) {
  switch (direction) {
    case 'POSITIVE':
      return true;
    case 'NEGATIVE':
      return false;
    default:
      return void 0;
  }
};

AUTO_CALC_EFFECT_MEASURES = ['RR', 'OR', 'VEOR', 'HR', 'VEHR'];

canAutoCalculateAbsLevel = function(result, level) {
  var denominator, riskProp, _ref1, _ref2;
  if (_ref1 = result.effectMeasure, __indexOf.call(AUTO_CALC_EFFECT_MEASURES, _ref1) < 0) {
    return false;
  }
  if (result.effectSize == null) {
    return false;
  }
  if (!((result.confidenceIntervalFrom != null) && (result.confidenceIntervalTo != null))) {
    return false;
  }
  denominator = (_ref2 = result.absDenominator) != null ? _ref2 : result.perPatients;
  if (denominator == null) {
    return false;
  }
  if (level === '') {
    return (result.controlCount != null) && (result.controlTotal != null);
  } else {
    riskProp = "" + (level.charAt(0).toLowerCase()) + (level.slice(1)) + "ControlRisk";
    return result[riskProp] != null;
  }
};

hasImportedAbsLevel = function(result, level) {
  return (result["absEffectSize" + level] != null) || (result["absEffectFrom" + level] != null) || (result["absEffectTo" + level] != null);
};

disableUnsupportedAbsAutoCalc = function(result) {
  var autoKey, level, _i, _len, _ref1;
  _ref1 = ['', 'Low', 'Moderate', 'High'];
  for (_i = 0, _len = _ref1.length; _i < _len; _i++) {
    level = _ref1[_i];
    autoKey = "absEffectAutoCalc" + level;
    if (!(result[autoKey] && hasImportedAbsLevel(result, level))) {
      continue;
    }
    if (!canAutoCalculateAbsLevel(result, level)) {
      result[autoKey] = false;
    }
  }
  return result;
};

mapDichotomousEffect = function(effect, options) {
  var direction, result;
  if (options == null) {
    options = {};
  }
  result = {};
  _.extend(result, mapGroupCounts(effect != null ? effect['intervention-group'] : void 0, 'intervention'));
  _.extend(result, mapGroupCounts(effect != null ? effect['comparator-group'] : void 0, 'control'));
  if (!options.omitEffectEstimates) {
    _.extend(result, mapRelativeMeasure(effect != null ? effect['relative-effect'] : void 0));
    _.extend(result, mapDichotomousAbsoluteEffects(effect));
    disableUnsupportedAbsAutoCalc(result);
  }
  direction = mapPreferredDirection(effect != null ? effect['preferred-direction'] : void 0);
  if (direction != null) {
    result.higherIsBetter = direction;
  }
  return result;
};

mapContinuousEffect = function(effect, options) {
  var direction, estimate, measure, otherLabel, result, _ref1;
  if (options == null) {
    options = {};
  }
  result = {};
  _.extend(result, mapGroupCounts(effect != null ? effect['intervention-group'] : void 0, 'intervention'));
  _.extend(result, mapGroupCounts(effect != null ? effect['comparator-group'] : void 0, 'control'));
  if (!options.omitEffectEstimates) {
    measure = effect != null ? effect['effect-measure'] : void 0;
    if (measure === 'OTHER') {
      otherLabel = (_ref1 = effect['other-effect-measure']) != null ? _ref1 : '';
      if (__indexOf.call(GRADEPRO_CONTINUOUS_OTHER_MEASURES, otherLabel) >= 0) {
        result.effectMeasure = otherLabel;
      } else {
        result.effectMeasure = 'other';
        result.otherMeasure = otherLabel;
      }
    } else if (measure != null) {
      result.effectMeasure = measure;
    }
    estimate = effect != null ? effect.estimate : void 0;
    if (estimate != null) {
      result.effectSize = parseNumber(estimate.value);
      result.confidenceIntervalFrom = parseNumber(estimate['ci-start']);
      result.confidenceIntervalTo = parseNumber(estimate['ci-end']);
    }
  }
  if (effect != null ? effect.unit : void 0) {
    result.units = effect.unit;
  }
  if (effect != null ? effect['comparator-effect'] : void 0) {
    _.extend(result, mapComparatorEffect(effect['comparator-effect']));
  }
  direction = mapPreferredDirection(effect != null ? effect['preferred-direction'] : void 0);
  if (direction != null) {
    result.higherIsBetter = direction;
  }
  return result;
};

mapComparatorEffect = function(comparatorEffect) {
  var end, result, start, text, value, valueType;
  if (!((comparatorEffect != null) && _.isObject(comparatorEffect) && !_.isArray(comparatorEffect))) {
    return {};
  }
  valueType = comparatorEffect['value-type'];
  switch (valueType) {
    case 'MEAN':
    case 'MEDIAN':
      result = {
        changeScoreInControls: valueType.toLowerCase()
      };
      value = parseNumber(comparatorEffect.value);
      if (value != null) {
        result.changeScoreInControlsValue = String(value);
      }
      return result;
    case 'RANGE':
      result = {
        changeScoreInControls: 'range'
      };
      start = parseNumber(comparatorEffect['range-start']);
      end = parseNumber(comparatorEffect['range-end']);
      if ((start != null) && (end != null)) {
        result.changeScoreInControlsValue = "" + start + "–" + end;
      }
      return result;
    case 'TEXT':
      text = htmlToPlainText(comparatorEffect['text-value']);
      if (text) {
        return {
          changeScoreInControlsValue: text
        };
      } else {
        return {};
      }
      break;
    default:
      return {};
  }
};

mapNarrativeEffect = function(effect) {
  return {
    narrativeDesc: htmlToPlainText(effect != null ? effect.description : void 0)
  };
};

hasEstimateData = function(estimate) {
  if (!((estimate != null) && _.isObject(estimate) && !_.isArray(estimate))) {
    return false;
  }
  return (parseNumber(estimate.value) != null) || (parseNumber(estimate['ci-start']) != null) || (parseNumber(estimate['ci-end']) != null);
};

hasPooledEstimate = function(type, effect) {
  var _ref1;
  if (type === 'cont') {
    return hasEstimateData(effect != null ? effect.estimate : void 0);
  } else if (type === 'narrative') {
    return false;
  } else {
    return hasEstimateData(effect != null ? (_ref1 = effect['relative-effect']) != null ? _ref1.estimate : void 0 : void 0);
  }
};

mapEvidenceSource = function(source) {
  var result;
  result = {};
  if ((source != null ? source.type : void 0) === 'PRIMARY_STUDY') {
    result.metaType = 'SINGLE_STUDY';
  } else if ((source != null ? source.type : void 0) === 'SYNTHESIS') {
    result.metaType = 'POOLED';
  }
  return result;
};

applyMetaType = function(outcome, pivotOutcome, type) {
  var effect, studyCount, _ref1;
  studyCount = parseNumber(pivotOutcome['study-count']);
  if (studyCount === 0) {
    outcome.metaType = 'NOT_REPORTED';
    return outcome;
  }
  effect = (_ref1 = pivotOutcome.effect) != null ? _ref1 : {};
  if (hasPooledEstimate(type, effect)) {
    _.extend(outcome, mapEvidenceSource(pivotOutcome['comparative-evidence-source']));
  } else {
    outcome.metaType = 'NOT_POOLED';
  }
  return outcome;
};

mapOutcomeType = function(pivotOutcome) {
  var effect, type, _ref1, _ref2;
  type = pivotOutcome['outcome-type'];
  if (type === 'OTHER_NUMERIC') {
    effect = (_ref1 = pivotOutcome.effect) != null ? _ref1 : {};
    if (effect.description && !effect['relative-effect']) {
      return 'narrative';
    } else {
      return 'dich';
    }
  } else {
    return (_ref2 = PIVOT_TO_OUTCOME_TYPE[type]) != null ? _ref2 : 'dich';
  }
};

ensureOutcomeRequiredDefaults = function(outcome) {
  if (outcome.effectMeasure == null) {
    outcome.effectMeasure = '';
  }
  if (outcome.effectRate == null) {
    outcome.effectRate = '';
  }
  if (outcome.effectDenominator == null) {
    outcome.effectDenominator = '';
  }
  if (outcome.effectOtherDenominator == null) {
    outcome.effectOtherDenominator = '';
  }
  if (outcome.effectDuration == null) {
    outcome.effectDuration = '';
  }
  if (outcome.effectOtherDuration == null) {
    outcome.effectOtherDuration = '';
  }
  if (outcome.effectCount == null) {
    outcome.effectCount = '';
  }
  if (outcome.effectTotal == null) {
    outcome.effectTotal = '';
  }
  if (outcome.comments == null) {
    outcome.comments = '';
  }
  if (outcome.populationDirectnessDesc == null) {
    outcome.populationDirectnessDesc = '';
  }
  if (outcome.interventionDirectnessDesc == null) {
    outcome.interventionDirectnessDesc = '';
  }
  if (outcome.comparisonDirectnessDesc == null) {
    outcome.comparisonDirectnessDesc = '';
  }
  if (outcome.direct_comparisonDirectnessDesc == null) {
    outcome.direct_comparisonDirectnessDesc = '';
  }
  if (outcome.outcomeDirectnessDesc == null) {
    outcome.outcomeDirectnessDesc = '';
  }
  if (outcome.populationDirectnessRadio == null) {
    outcome.populationDirectnessRadio = '';
  }
  if (outcome.interventionDirectnessRadio == null) {
    outcome.interventionDirectnessRadio = '';
  }
  if (outcome.comparisonDirectnessRadio == null) {
    outcome.comparisonDirectnessRadio = '';
  }
  if (outcome.direct_comparisonDirectnessRadio == null) {
    outcome.direct_comparisonDirectnessRadio = '';
  }
  if (outcome.outcomeDirectnessRadio == null) {
    outcome.outcomeDirectnessRadio = '';
  }
  if (outcome.lowControl == null) {
    outcome.lowControl = false;
  }
  if (outcome.moderateControl == null) {
    outcome.moderateControl = false;
  }
  if (outcome.highControl == null) {
    outcome.highControl = false;
  }
  if (outcome.lowControlRisk == null) {
    outcome.lowControlRisk = 0;
  }
  if (outcome.moderateControlRisk == null) {
    outcome.moderateControlRisk = 0;
  }
  if (outcome.highControlRisk == null) {
    outcome.highControlRisk = 0;
  }
  if (outcome.followUpLength == null) {
    outcome.followUpLength = 0;
  }
  if (outcome.followUpLengthTo == null) {
    outcome.followUpLengthTo = 0;
  }
  if (outcome.withOutcome == null) {
    outcome.withOutcome = 0;
  }
  if (outcome.withoutOutcome == null) {
    outcome.withoutOutcome = 0;
  }
  if (outcome.noOfStudies == null) {
    outcome.noOfStudies = 0;
  }
  return outcome;
};

mapOutcome = function(pivotOutcome, footnotesState, orderNumber) {
  var design, effect, omitEffectEstimates, outcome, pivotQuality, qualityAttrs, studyCount, type, _ref1, _ref2;
  type = mapOutcomeType(pivotOutcome);
  outcome = {
    name: htmlToPlainText(nameOf(pivotOutcome)),
    type: type,
    orderNumber: orderNumber,
    footnotes: {},
    references: {}
  };
  studyCount = parseNumber(pivotOutcome['study-count']);
  if (studyCount != null) {
    outcome.noOfStudies = studyCount;
  }
  design = designStudiesFor(pivotOutcome['study-type']);
  if (design != null) {
    outcome.designStudies = _.clone(design);
  }
  _.extend(outcome, mapTimeframe(pivotOutcome.timeframe));
  applyMetaType(outcome, pivotOutcome, type);
  effect = (_ref1 = pivotOutcome.effect) != null ? _ref1 : {};
  omitEffectEstimates = (_ref2 = outcome.metaType) === 'NOT_POOLED' || _ref2 === 'NOT_REPORTED';
  if (type === 'cont') {
    _.extend(outcome, mapContinuousEffect(effect, {
      omitEffectEstimates: omitEffectEstimates
    }));
  } else if (type === 'narrative') {
    _.extend(outcome, mapNarrativeEffect(effect));
  } else {
    _.extend(outcome, mapDichotomousEffect(effect, {
      omitEffectEstimates: omitEffectEstimates
    }));
  }
  qualityAttrs = mapQuality(pivotOutcome.quality, footnotesState);
  pivotQuality = qualityAttrs._pivotQuality;
  delete qualityAttrs._pivotQuality;
  _.extend(outcome, qualityAttrs);
  if (pivotQuality != null) {
    applyOverallQualityToDomains(outcome, pivotQuality);
  } else if (qualityAttrs.riskOfBias == null) {
    outcome.omitCalculatedQuality = true;
  }
  if (PIVOT_TO_IMPORTANCE[pivotOutcome.importance] != null) {
    outcome.importance = Number(PIVOT_TO_IMPORTANCE[pivotOutcome.importance]);
  }
  if (pivotOutcome.comment) {
    outcome.comments = htmlToPlainText(pivotOutcome.comment);
  }
  if (type !== 'narrative' && pivotOutcome['outcome-type'] === 'OTHER_NUMERIC' && effect.description) {
    outcome.narrativeDesc = htmlToPlainText(effect.description);
  }
  return ensureOutcomeRequiredDefaults(outcome);
};

isNamedIdentifierField = function(field) {
  if (!((field != null) && _.isObject(field) && !_.isArray(field))) {
    return false;
  }
  return _.isString(field.name);
};

isStringName = function(value) {
  return _.isString(value) && value.trim() !== '';
};

isValidCiLevel = function(value) {
  var num;
  if (value == null) {
    return true;
  }
  num = parseNumber(value);
  if (num == null) {
    return false;
  }
  return num === DEFAULT_CI_LEVEL;
};

isValidSof = function(sof) {
  var required;
  if (!((sof != null) && _.isObject(sof) && !_.isArray(sof))) {
    return false;
  }
  if (!_.isArray(sof.outcomes)) {
    return false;
  }
  if (!isStringName(sof.name)) {
    return false;
  }
  if (!isValidCiLevel(sof['ci-level'])) {
    return false;
  }
  required = ['population', 'setting', 'intervention', 'comparator'];
  if (!_.every(required, function(key) {
    return isNamedIdentifierField(sof[key]);
  })) {
    return false;
  }
  return _.every(sof.outcomes, function(outcome) {
    var _ref1;
    if (!((outcome != null) && _.isObject(outcome))) {
      return false;
    }
    if (!isStringName(outcome.name)) {
      return false;
    }
    return _ref1 = outcome['outcome-type'], __indexOf.call(VALID_OUTCOME_TYPES, _ref1) >= 0;
  });
};

module.exports = {
  isValidSof: isValidSof,
  normalizeSofList: function(json) {
    var invalid, list, unsupportedCi;
    list = _.isArray(json) ? json : [json];
    unsupportedCi = _.find(list, function(item) {
      return ((item != null ? item['ci-level'] : void 0) != null) && !isValidCiLevel(item['ci-level']);
    });
    if (unsupportedCi != null) {
      throw new Error('unsupportedCiLevel');
    }
    invalid = _.find(list, function(item) {
      return !isValidSof(item);
    });
    if (invalid != null) {
      throw new Error('invalidPivotFormat');
    }
    return list;
  },
  importSof: function(sof) {
    var footnotesState, outcomes, question, tableName, _ref1;
    footnotesState = {
      notes: {},
      currentId: 0,
      idsOrder: ['no_explanation_provided']
    };
    outcomes = _.map((_ref1 = sof.outcomes) != null ? _ref1 : [], function(pivotOutcome, idx) {
      return mapOutcome(pivotOutcome, footnotesState, idx + 1);
    });
    question = {
      docType: 'question',
      type: 'management',
      healthProblemOrPopulation: htmlToPlainText(nameOf(sof.population)),
      intervention: htmlToPlainText(nameOf(sof.intervention)),
      comparison: htmlToPlainText(nameOf(sof.comparator)),
      settings: htmlToPlainText(nameOf(sof.setting)),
      outcomes: outcomes,
      footnotes: {},
      references: {},
      recommendationIds: [],
      questionNo: 0,
      date: '',
      authors: '',
      manualTableTitle: false,
      comparatorTestPresent: false,
      $tableMode: 'regular',
      footnotesList: {
        notes: footnotesState.notes,
        currentId: footnotesState.currentId,
        idsOrder: footnotesState.idsOrder
      }
    };
    if (sof.name != null) {
      tableName = htmlToPlainText(sof.name);
      if (tableName) {
        question.tableTitle = tableName;
        question.manualTableTitle = true;
      }
    }
    return question;
  },
  _test: {
    mapOutcome: mapOutcome,
    mapDichotomousEffect: mapDichotomousEffect,
    mapContinuousEffect: mapContinuousEffect,
    mapTimeframe: mapTimeframe,
    mapComparatorEffect: mapComparatorEffect,
    htmlToPlainText: htmlToPlainText
  }
};
